/* This is the Climate Change Component N.12  */

<template>
  <v-container>
    <div>
      <strong><span v-html="title"></span></strong>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;" width="800px;">
        <tbody>
          <tr>
            <td style="width: 500px; height: 25px; text-align: center">
              ប្រភពថវិកា
            </td>
            <td style="width: 300px; height: 25px; text-align: center">
              ចំនួន (គិតជារៀល)
            </td>
          </tr>
          <tr
            v-for="(value, row) in sch_fun.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 500px; height: 25px">{{ sch_fun[row] }}</td>
            <td style="width: 300px; height: 25px">
              <numberinput
                v-model="data[row].d"
                style="width: 300px; text-align: center"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { sch_fun } from "@/utils/ascf/climateVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      sch_fun: sch_fun,
    };
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
</style>